import React from "react";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
import { Form, Col, Row } from "reactstrap";

const translator = require("../../../../utils/translator/translator");

class CustomerDetails extends React.PureComponent 
{
    state = {
        dropdownOpen: false
    }
    render() 
    {
        return (
            <Form>
                <Row className="mb-3">
                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_customer_name")}
                            value={this.props.values.customerName}
                            onValueChange={(value) => this.props.handleValueChange("customerName", value)}
                            inputTextType="text"
                            error={this.props.error.fieldName === "customerName" ? this.props.error.message : ""}
                            internalRef={this.props.inputFieldRef}
                        />
                    </Col>
                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_customer_phone_number")}
                            value={this.props.values.customerPhoneNumber}
                            onValueChange={(value) => this.props.handleValueChange("customerPhoneNumber", value)}
                            inputTextType="tel"
                            error={this.props.error.fieldName === "customerPhoneNumber" ? this.props.error.message : ""}
                        />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <InputTextComponent 
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_customer_delivery_address")}
                            value={this.props.values.deliveryAddress}
                            onValueChange={(value) => this.props.handleValueChange("deliveryAddress", value)}
                            inputTextType="text"
                            error={this.props.error.fieldName === "deliveryAddress" ? this.props.error.message : ""}
                        />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <InputTextComponent 
                            autoComplete="off"
                            type="textarea"
                            style={{height: '100px'}}
                            placeholder={translator.getLabel("venue_dialogue_instructions")}
                            value={this.props.values.instructions}
                            onValueChange={(value) => this.props.handleValueChange("instructions", value)}
                            inputTextType="text"
                            error={this.props.error.fieldName === "instructions" ? this.props.error.message : ""}
                        />
                    </Col>
                </Row>
            </Form>
        );
    }

}

export default CustomerDetails